var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.004 1.317H2.317c-.638 0-1.196.46-1.196 1.091v11.713c0 .634.558 1.2 1.196 1.2h11.684c.642 0 1.123-.57 1.123-1.2V2.408c.004-.631-.482-1.09-1.12-1.09M5.461 12.99H3.455V6.752h2.006zm-.933-7.186h-.015c-.642 0-1.057-.478-1.057-1.076 0-.61.426-1.076 1.083-1.076.656 0 1.058.463 1.072 1.076 0 .598-.416 1.076-1.083 1.076m8.265 7.186h-2.006V9.58c0-.818-.292-1.376-1.018-1.376-.554 0-.882.375-1.028.74-.055.132-.07.31-.07.493v3.553H6.665V6.752h2.006v.868c.292-.415.748-1.014 1.81-1.014 1.316 0 2.312.868 2.312 2.74z"
  })));
};
export default SvgLinkedin;